<template>
  <div class="content">
    <div class="section-type-c">
      <div class="hero section-type-b bground-config-clean position-relative" :style="{ backgroundImage: `url('${backgroundCarImage}')` }">
        <div class="personal-container advertisements">
          <div class="row section-type-b pt-5">
            <div class="col-12 presentation-inner-padding-top2">
              <div>
                <h1 class="text-light text-center mb-24">
                  ¡Ya casi es tuyo!
                </h1>
                <p class="text-light text-center mb-64">
                  Estás a pocos clic de llevarte tu siguiente auto
                </p>
              </div>
              <div class="car-description-hero">
                <div class="car-x2">
                  <img :src="informacionVersion.portada" class="w-100 car-description-principal-center spark2020_1231" alt="Chevrolet Spark color ocre">
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="row justify-content-center no-gutters p-3">
        <div class="col-12 col-md-8 col-lg-10">
          <div class="row car-search">
            <div class="col-12 col-lg-6 p-4 vertical-align">
              <div>
                <h3 class="mb-24">Elije el plan de financiamiento que desees</h3>
                <form>
                  <div class="form-group mb-32">
                    <h4>
                      {{ informacionVersion.nombre }}
                    </h4>
                    <!-- <p>Color: Ocre</p>
                    <span class="pointer-color-selector orange" onclick="setColorCar('spark2020_1231','orange', './resources/autos/chevrolet/spark/')"></span> -->
                  </div>
                  <div class="form-group mb-32">
                    <label for="prices">Forma de pago</label>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="paymentform" id="cash" value="cash">
                        <label class="form-check-label" for="cash">
                          Contado
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="paymentform" id="credit" value="credit" checked>
                        <label class="form-check-label" for="credit">
                          Crédito
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="paymentform" id="flexpay" value="Flex pay" checked>
                        <label class="form-check-label" for="flexpay">
                          Flex pay
                        </label>
                      </div>
                       <div class="form-check">
                        <input class="form-check-input" type="radio" name="paymentform" id="Leasing" value="Leasing" checked>
                        <label class="form-check-label" for="Leasing">
                          Leasing
                        </label>
                      </div>
                  </div>
                  <div class="form-group mb-32">
                    <label for="formControlRange">Enganche</label>
                    <div class="d-flex"><h4 class="" id="rangeValue">{{informacionVersion.financiamientos[0].engancheSugerido}} </h4> %</div>
                    <div class="d-flex">
                      <div class="w-100">
                        <input id="ranger" type="range" v-model="informacionVersion.financiamientos[0].engancheSugerido" :min="0" max="60" class="form-control-range">
                      </div>
                      <div>

                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-32">
                    <label for="msi">¿Cuántas mensualidades?</label>
                    <select class="form-control" id="msi" v-model="selected">
                      <option>12</option>
                      <option>24</option>
                      <option>36</option>
                      <option>48</option>
                    </select>
                    <span>Seleccionado: {{ selected }}</span>
                  </div>
                </form>
                <table class="table table-striped">
                  <tbody>
                  <tr class="text-center">
                    <td class="p-0">
                      <a href="/solicitud-creditoL" class="btn nw-buttons text-light d-block mx-auto bg-advanced-consulting"><h5>Elegir plan de financiamiento</h5></a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="pricing p-2 pt-4">
                <label class="d-block text-center font-weight-bold cl-advanced-consulting">Versión</label>
                <h2 class="text-center">{{ informacionVersion.nombre }}</h2>
                <h4 class="text-center"><sup style="font-size: 17px;">$</sup>{{ informacionVersion.mensualidad }}.00<span style="font-size: 15px;">MXN/Mes</span></h4>
                <br>
                <table class="table table-striped">
                  <tbody>
                  <tr class="text-center">
                    <td class="min-height-td-pricing">
                      <strong class="">Enganche:</strong><br>
                      <p>{{ Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(informacionVersion.enganche ? informacionVersion.enganche* (informacionVersion.financiamientos[0].engancheSugerido / 100): '00')}}</p>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <td class="min-height-td-pricing">
                      <strong class="">Al mes:</strong><br>
                      <p>{{ Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format((informacionVersion.contado - informacionVersion.enganche)/selected)}}</p>
                      <!-- <p>{{(informacionVersion.contado - informacionVersion.enganche)/selected}}</p>
                      <p>{{informacionVersion.enganche}}</p>
                      <p>{{selected}}</p> -->
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table class="table table-striped">
                  <tbody>
                  <tr>
                    <td class="text-center">Transmisión</td>
                    <td  class="text-left">STD</td>
                  </tr>
                  <tr>
                    <td class="text-center">Rendimiento</td>
                    <td  class="text-left">20.7 Km/L</td>
                  </tr>
                  <tr>
                    <td class="text-center">Bolsas de aire</td>
                    <td  class="text-left">{{informacionVersion.bolsasAire}}</td>
                  </tr>
                  <tr>
                    <td class="text-center">Frenos ABS</td>
                    <td  class="text-left"><i class="fas fa-check"></i></td>
                  </tr>
                  <tr>
                    <td class="text-center">Aire acondicionado</td>
                    <td  class="text-left"><i class="fas fa-check"></i></td>
                  </tr>
                  <tr>
                    <td class="text-center">Controles de audio al volante</td>
                    <td  class="text-left"><i class="fas fa-check"></i></td>
                  </tr>
                  <tr>
                    <td class="text-center">Bocinas</td>
                    <td  class="text-left">{{informacionVersion.bocinas}}</td>
                  </tr>
                  <tr>
                    <td class="text-center">Motor</td>
                    <td  class="text-left">{{informacionVersion.rines}}</td>
                  </tr>
                  <tr>
                    <td class="text-center">Pantalla con Bluetooth</td>
                    <td  class="text-left">{{informacionVersion.pantallaBt}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-type-b pt-5 pb-5 mb-64 presentation">
      <div class="personal-container">
        <div class="mb-64">
          <h1 class="text-center text-light">Las personas que vieron {{ informacionVersion.nombre }} también vieron:</h1>
        </div>
        <div class="row justify-content-center">
          <CocheCard v-bind:key="coche.idVehiculo" v-for="coche in coches"
                     :id="coche.idVehiculo"
                     :urlBackgroundImage="coche.portada"
                     :carModel="coche.nombre"
                     :releaseYear="coche.nombre"
                     :initialPayment=coche.contado
                     :monthlyCost=coche.mensualidad
          ></CocheCard>
        </div>
      </div>
    </div>
    <ModalPlanFinanciamiento></ModalPlanFinanciamiento>
  </div>
</template>

<script>
import CocheCard from '@/components/CocheCard'
import ModalPlanFinanciamiento from '@/components/ModalPlanFinanciamiento'

export default {
  name: 'ProcesoFinanciamiento',
  components: {
    CocheCard,
    ModalPlanFinanciamiento
  },
  data () {
    return {
      backgroundCarImage: require('@/assets/images/presentation.jpg'),
      range: 50,
      coches: [],
      selected: 0,
      informacionVersion: {},
      options: [
        { id: 0, labels: 'Vegetables' },
        { id: 1, labels: 'Cheese' },
        { id: 2, labels: 'Fruits' }
      ],
      idVersion: 0
    }
  },
  methods: {
    getData (evt) {
      console.log(evt)
    }
  },
  async mounted () {
    const b = await this.$http.get('/web/vehicles/random')
    this.coches = b.data.data
    this.idVersion = this.$route.params.id
    const a = await this.$http.get('/web/vehicles/version/' + this.idVersion)
    this.informacionVersion = a.data.data
  }
}
</script>

<style scoped>

</style>
